export default __webpack_public_path__ + "static/media/textlayer.3f48108e.txt";